import { useEffect } from 'react'
import './Servicios.css'
import ProfileCard from '../ProfileCard/ProfileCard'
import ScrollStack, { ScrollStackItem } from '../ScrollStack/ScrollStack'
import { Link } from "react-router-dom";
function Servicios() {


    useEffect(() => {
        const handleScroll = () => {
            const bg = document.querySelector('.uno .dos');
            if (bg) {
                const scrollValue = window.scrollY;
                const sectionOffset = bg.parentElement.offsetTop;
                const screenHeight = window.innerHeight;

                // Solo movemos si la sección es visible en pantalla
                if (scrollValue + screenHeight > sectionOffset) {
                    const yPos = (scrollValue - sectionOffset) * 0.2; // 0.2 es la velocidad
                    bg.style.transform = `translateY(${yPos}px)`;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const els = document.querySelectorAll('.team-section .reveal');
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
        els.forEach(el => io.observe(el));
        return () => io.disconnect();
    }, []);

    const useWindowScrollForStack = typeof window !== 'undefined' && window.innerWidth <= 768;

    return (

        <div className='degradado'>
            <div className='servicios'>
                <h1 className='titulo dos'>SERVICIOS DRONTALIA</h1>
            </div>


            <section className="porada">
                <Link to='/inspecciones#inspecciones' className="item one">
                    <img className="porta" loading="lazy" src="/media/porada1.webp" alt="Inspecciones técnicas" />
                    <div className="porada__overlay" />
                    <div className="porada__content">
                        <span className="porada__num">01 / 03</span>
                        <h2 className="tituloDos">INSPECCIONES TÉCNICAS</h2>
                        <span className="porada__arrow" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </span>
                    </div>
                </Link>

                <Link to='/soluciones#soluciones' className="item two">
                    <img className="porta" loading="lazy" src="/media/porada2.webp" alt="Soluciones geoespaciales" />
                    <div className="porada__overlay" />
                    <div className="porada__content">
                        <span className="porada__num">02 / 03</span>
                        <h2 className="tituloDos">SOLUCIONES GEOESPACIALES</h2>
                        <span className="porada__arrow" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </span>
                    </div>
                </Link>

                <Link to='/seguridad#seguridad' className="item three">
                    <img className="porta" loading="lazy" src="/media/porada3.webp" alt="Seguridad y medioambiente" />
                    <div className="porada__overlay" />
                    <div className="porada__content">
                        <span className="porada__num">03 / 03</span>
                        <h2 className="tituloDos">SEGURIDAD Y MEDIOAMBIENTE</h2>
                        <span className="porada__arrow" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </span>
                    </div>
                </Link>







            </section>
            {/*<div className="Ter">
                <video className='termico' src="/img/videoTer.mov" loop muted autoPlay controls></video>
            </div>*/}

            <div className="nosotros dos">
                <h2 id='dron' className='subtitulo tres'>
                    CARACTERÍSTICAS DEL DRON
                </h2>
            </div>

            <ScrollStack useWindowScroll={useWindowScrollForStack}>

                <ScrollStackItem itemClassName='spec-card spec-card--optics'>
                    <div className='spec-card__head'>
                        <span className='spec-card__icon' aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="6" width="20" height="14" rx="2"></rect>
                                <circle cx="12" cy="13" r="4"></circle>
                                <path d="M7 6l1.5-2h7L17 6"></path>
                            </svg>
                        </span>
                        <div>
                            <span className='spec-card__eyebrow'>01 / ÓPTICAS</span>
                            <h3 className='spec-card__title'>CÁMARAS PRINCIPALES</h3>
                        </div>
                    </div>
                    <div className='spec-card__grid'>
                        <article className='spec-block'>
                            <h4 className='spec-block__name'>Gran angular</h4>
                            <dl className='spec-block__rows'>
                                <div><dt>Sensor</dt><dd>CMOS 1/1.3″</dd></div>
                                <div><dt>Resolución</dt><dd>48 MP</dd></div>
                                <div><dt>Apertura</dt><dd>f/1.7</dd></div>
                                <div><dt>Focal eq.</dt><dd>24 mm</dd></div>
                            </dl>
                        </article>
                        <article className='spec-block'>
                            <h4 className='spec-block__name'>Telecámara media</h4>
                            <dl className='spec-block__rows'>
                                <div><dt>Sensor</dt><dd>CMOS 1/1.3″</dd></div>
                                <div><dt>Resolución</dt><dd>48 MP</dd></div>
                                <div><dt>Apertura</dt><dd>f/2.8</dd></div>
                                <div><dt>Focal eq.</dt><dd>70 mm</dd></div>
                            </dl>
                        </article>
                        <article className='spec-block'>
                            <h4 className='spec-block__name'>Telecámara</h4>
                            <dl className='spec-block__rows'>
                                <div><dt>Sensor</dt><dd>CMOS 1/1.5″</dd></div>
                                <div><dt>Resolución</dt><dd>48 MP</dd></div>
                                <div><dt>Apertura</dt><dd>f/2.8</dd></div>
                                <div><dt>Focal eq.</dt><dd>168 mm</dd></div>
                            </dl>
                        </article>
                    </div>
                </ScrollStackItem>

                <ScrollStackItem itemClassName='spec-card spec-card--sensors'>
                    <div className='spec-card__head'>
                        <span className='spec-card__icon' aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 12h3"></path>
                                <path d="M18 12h3"></path>
                                <path d="M12 3v3"></path>
                                <path d="M12 18v3"></path>
                                <circle cx="12" cy="12" r="4"></circle>
                                <circle cx="12" cy="12" r="8" opacity="0.4"></circle>
                            </svg>
                        </span>
                        <div>
                            <span className='spec-card__eyebrow'>02 / SENSORES</span>
                            <h3 className='spec-card__title'>SENSORES AVANZADOS</h3>
                        </div>
                    </div>
                    <div className='spec-card__grid'>
                        <article className='spec-block'>
                            <h4 className='spec-block__name'>Telémetro láser</h4>
                            <dl className='spec-block__rows'>
                                <div><dt>Rango</dt><dd>1800 m (1 Hz)</dd></div>
                                <div><dt>Incidencia oblicua</dt><dd>600 m (1 Hz)</dd></div>
                                <div><dt>Zona ciega</dt><dd>1 m</dd></div>
                                <div><dt>Precisión</dt><dd>±(0.2 + 0.0015 × D)</dd></div>
                            </dl>
                        </article>
                        <article className='spec-block'>
                            <h4 className='spec-block__name'>Cámara térmica IR</h4>
                            <dl className='spec-block__rows'>
                                <div><dt>Resolución</dt><dd>640 × 512</dd></div>
                                <div><dt>Apertura</dt><dd>f/1.0</dd></div>
                                <div><dt>Focal eq.</dt><dd>53 mm</dd></div>
                                <div><dt>Microbolómetro</dt><dd>VOx no refrigerado</dd></div>
                            </dl>
                        </article>
                        <article className='spec-block'>
                            <h4 className='spec-block__name'>Luz NIR auxiliar</h4>
                            <dl className='spec-block__rows'>
                                <div><dt>Campo de visión</dt><dd>6°</dd></div>
                                <div><dt>Iluminación</dt><dd>100 m</dd></div>
                            </dl>
                        </article>
                    </div>
                </ScrollStackItem>

                <ScrollStackItem itemClassName='spec-card spec-card--visual'>
                    <img className='spec-card__photo' loading="lazy" src="/media/camara.webp" alt="Payload del dron" />
                    <div className='spec-card__photoOverlay'>
                        <span className='spec-card__eyebrow'>03 / PAYLOAD</span>
                        <h3 className='spec-card__title'>SISTEMA DE CAPTURA INTEGRADO</h3>
                    </div>
                </ScrollStackItem>

            </ScrollStack>

            <div className="separador uno">
                <div className="bg dos"></div>
                <div className="overlay"></div>
            </div>

            <section className='team-section'>
                <div className='servicios'>
                    <h1 className='titulo dos'>QUIÉNES SOMOS </h1>
                </div>
                <div className="flex tres">
                <div className="izquierda reveal">
                    <ProfileCard
                        name="VERÓNICA"
                        title={
                            <>
                                Piloto de RPAS <br />
                                Responsable de Ventas <br /><br />
                            </>
                        }
                        handle="DRONTALIA"
                        status="Online"
                        contactText="Contact Me"
                        avatarUrl="/media/vero.webp"
                        showUserInfo={false}
                        enableTilt={true}
                        enableMobileTilt={false}
                        onContactClick={() => console.log('Contact clicked')}
                        behindGlowColor="rgba(125, 190, 255, 0.67)"
                        iconUrl="/media/pattern2.webp"
                        behindGlowEnabled
                        innerGradient="linear-gradient(145deg,#60496e8c 0%,#71C4FF44 100%)"
                    />
                    <span className="role-chip">
                        <span className="role-chip__dot" aria-hidden="true" />
                        PILOTO RPAS · VENTAS
                    </span>
                </div>
                <div className="derecha reveal">
                    <ProfileCard
                        name="RODRIGO"
                        title={
                            <>
                                Piloto de RPAS<br />
                                Máster en Ciencia de Datos <br /><br />
                            </>
                        }
                        handle="DRONTALIA"
                        status="Online"
                        contactText="Contact Me"
                        avatarUrl="/media/rodri.webp"
                        showUserInfo={false}
                        enableTilt={true}
                        enableMobileTilt={false}
                        onContactClick={() => console.log('Contact clicked')}
                        behindGlowColor="rgba(125, 190, 255, 0.67)"
                        iconUrl="/media/pattern2.webp"
                        behindGlowEnabled
                        innerGradient="linear-gradient(145deg,#60496e8c 0%,#71C4FF44 100%)"
                    />
                    <span className="role-chip">
                        <span className="role-chip__dot" aria-hidden="true" />
                        PILOTO RPAS · DATOS
                    </span>
                </div>
                </div>
            </section>
        </div>

    )
}

export default Servicios
